export type DashboardTab = 'all' | 'users' | 'invoices' | 'bounceEmails';

type DashboardTabsProps = {
  activeTab: DashboardTab;
  onTabChange: (tab: DashboardTab) => void;
};

const tabs: { id: DashboardTab; label: string }[] = [
  { id: 'all', label: 'All' },
  { id: 'invoices', label: 'Invoices' },
  { id: 'users', label: 'Users' },
  { id: 'bounceEmails', label: 'Bounce Emails' },
];

function DashboardTabs({ activeTab, onTabChange }: DashboardTabsProps) {
  return (
    <>
      {tabs.map((tab) => (
        <button
          key={tab.id}
          type="button"
          onClick={() => onTabChange(tab.id)}
          className={`rounded-xl px-4 py-2 text-sm font-semibold transition ${
            activeTab === tab.id
              ? 'bg-indigo-600 text-white shadow-sm shadow-indigo-300/50'
              : 'bg-transparent text-slate-600 hover:bg-slate-100'
          }`}
        >
          {tab.label}
        </button>
      ))}
    </>
  );
}

export default DashboardTabs;
